import React from 'react';
import { isKiosk } from '../../../../utils/isKiosk';
import { InventoryStatus as InventoryStatusType } from '../../../../types';
import { Icon, InventoryBorder, InventoryMessage, StoreCtaLink } from './styles';

/*
  Default InventoryStatus UI component
*/

const InventoryStatus = ({
  badges,
  page,
  changeStoreLabel,
  ctaHandleClick,
  InventoryStatusMessage,
  hideChangeStoreCta = false,
}) => {
  const isKioskMode = isKiosk();

  return (
    <InventoryBorder className={page}>
      <Icon image={badges[0]?.inventoryStatusIcon} className={page} />
      <InventoryMessage
        data-testid="inventory-message"
        className={page}
        isKiosk={isKioskMode}
      >
        {InventoryStatusMessage}
      </InventoryMessage>
      {(!hideChangeStoreCta && changeStoreLabel)
      && (
      <StoreCtaLink
        type="button"
        className="pointer"
        data-testid="inventory-message"
        onClick={ctaHandleClick}
      >
        {changeStoreLabel}
      </StoreCtaLink>
      )}
      
    </InventoryBorder>
  );
};

/*
Renders badge for accessory page or if the page is undefined (default)
*/
export const ProductDetailBadge = ({
  activeStore,
  inventoryLabels,
  handleClick,
  badges,
  page,
  apiError,
  inventoryStatus,
  offer,
}) => {
  const isKioskMode = isKiosk();
  
  const renderInventoryStatusMessage = () => {
    let statusMessageComponent = (
      <span>
        {badges[0]?.inventoryStatusMessage?.inventoryStatusMessage}
      </span>
    );
    if (inventoryStatus === InventoryStatusType.InStock
      && Number.parseInt(offer?.quantity, 10) >= 5) {
      statusMessageComponent = (
        <span>
          <b>
            {`${offer?.quantity} ${inventoryLabels.phonesQuantityLabel} `}
          </b>
          {badges[0]?.inventoryStatusMessage?.inventoryStatusMessage}
        </span>
      );
    } else if (inventoryStatus === InventoryStatusType.InStock
      && Number.parseInt(offer?.quantity, 10) < 5) {
      badges[0] = inventoryLabels?.inventoryStatus.find(
        status => status.inventoryStatusCode === InventoryStatusType.ShipToStore,
      );

      return (
        <span>
          {badges[0]?.inventoryStatusMessage?.inventoryStatusMessage}
        </span>
      );
    }

    if (inventoryStatus === InventoryStatusType.OutOfStock && offer?.inventoryMessageOverride) {
      badges[0] = offer?.inventoryMessageOverride;
      
      return (
        <span>
          {badges[0]?.inventoryStatusMessage?.inventoryStatusMessage}
        </span>
      );
    }
    return statusMessageComponent;
  };

  if (!activeStore && inventoryLabels?.storeNotSelectedMessage) {
    return (
      <InventoryBorder>
        <Icon image={inventoryLabels?.storeNotSelectedIcon} />
        <InventoryMessage
          isKiosk={isKioskMode}
        >
          {inventoryLabels?.storeNotSelectedMessage?.storeNotSelectedMessage}
          <StoreCtaLink
            type="button"
            className="pointer"
            data-testid="inventory-message"
            onClick={handleClick}
          >
            {inventoryLabels?.selectStoreCta?.ctaLabel?.ctaLabel}
          </StoreCtaLink>
        </InventoryMessage>
      </InventoryBorder>
    );
  }

  const displayStatus = activeStore
    && badges
    && badges.length
    && badges[0]?.inventoryStatusIcon
    && (!apiError || (apiError && page === 'accessoryProductDetail'));

  return displayStatus ? (
    <InventoryStatus
      page={page}
      badges={badges}
      changeStoreLabel={inventoryLabels?.changeStoreCta?.ctaLabel?.ctaLabel}
      ctaHandleClick={handleClick}
      InventoryStatusMessage={renderInventoryStatusMessage()}
      hideChangeStoreCta={isKioskMode || offer?.inventoryMessageOverride}
    />
  ) : null;
};

/*
Renders badge for reserve phone page
*/
export const ReservationBladeBadge = ({
  activeStore,
  inventoryLabels,
  apiError,
  badges,
  page,
  selectedCarrier,
  selectedSKU,
}) => {
  const isKioskMode = isKiosk();
  
  const InventoryStatusMessage = (
    <span>
      {badges?.[0]?.inventoryStatusMessage?.inventoryStatusMessage}
    </span>
  );
  // Carrier not selected
  if (
    !selectedCarrier
    && !selectedSKU
    && inventoryLabels?.carrierNotSelectedMessage
  ) {
    return (
      <InventoryBorder className={page}>
        <Icon
          image={inventoryLabels?.carrierNotSelectedIcon}
          className={page}
        />
        <InventoryMessage
          data-testid="inventory-message"
          className={page}
          isKiosk={isKioskMode}
        >
          {
            inventoryLabels?.carrierNotSelectedMessage
              ?.carrierNotSelectedMessage
          }
        </InventoryMessage>
      </InventoryBorder>
    );
  }

  const displayStatus = activeStore
    && badges
    && badges.length
    && badges[0]?.inventoryStatusIcon
    && !apiError;

  return displayStatus ? (
    <InventoryStatus
      page={page}
      badges={badges}
      changeStoreLabel={null}
      ctaHandleClick={null}
      InventoryStatusMessage={InventoryStatusMessage}
      hideChangeStoreCta={isKioskMode}
    />
  ) : null;
};
